import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { DiagnosticsActions } from '../../store';
import { ColumnArrow } from '../ColumnArrow';
import { GreyButton } from '../GreyButton';
import { PrimaryButton } from '../PrimaryButton';
import { SearchBar } from '../SearchBar';
import { Modal } from '../Modal';
import './DiagnosticsModal.css';
import darkSkyIcon from './assets/darksky-icon.png';
import { InlineEditable } from '../InlineEditable';

export class DiagnosticsModal extends Component {
  state = {
    filteredRegisterList: [],
    filters: { searchValue: '', sortValue: 'modbus_register', isReversed: false },
    modalAvailableColors: JSON.parse(window.sessionStorage.getItem('availableColors')),
    modalLineColorObj: JSON.parse(window.sessionStorage.getItem('lineColorObj')),
    editableContent: {},
  };

  componentDidMount() {
    this.updateFilteredRegisterList();
  }

  handleModalClose() {
    this.props.onRequestClose();
  }

  handleCheckboxChange(tag) {
    let tmpLineColorObj = JSON.parse(JSON.stringify(this.state.modalLineColorObj));
    const tmpAvailableColors = Array.from(this.state.modalAvailableColors);

    if (!tmpLineColorObj[tag]) {
      // checking a new register
      const pair = { [tag]: tmpAvailableColors.shift() };
      tmpLineColorObj = { ...tmpLineColorObj, ...pair };
    } else {
      // unchecking a previously selected register
      tmpAvailableColors.push(tmpLineColorObj[tag]);
      delete tmpLineColorObj[tag];
    }

    this.setState((state) => ({
      ...state,
      modalLineColorObj: tmpLineColorObj,
      modalAvailableColors: tmpAvailableColors,
    }));
  }

  updateSearchValue = (event) => {
    const filterList = this.state.filters;
    filterList.searchValue = event.target.value;

    this.setState(
      (state) => ({
        ...state,
        filters: filterList,
      }),
      () => this.updateFilteredRegisterList(),
    );
  };

  updateSortValue = (sortValue) => {
    const isReversed = sortValue === this.state.filters.sortValue && !this.state.filters.isReversed;
    this.setState(
      (state) => ({
        ...state,
        filters: {
          ...state.filters,
          isReversed,
          sortValue,
        },
      }),
      () => this.updateFilteredRegisterList(),
    );
  };

  updateFilteredRegisterList() {
    const { filters, filteredRegisterList = [], modalLineColorObj } = this.state;
    const { dataPointsList } = this.props;
    let tempRegisterList = filteredRegisterList.length > 0 ? filteredRegisterList : [...dataPointsList];
    let unsortedList = [];
    const x = filters.searchValue.charAt(0);
    const regex = /^[a-zA-Z]+$/;
    const filterList = { ...filters };

    if (filters.searchValue !== '') {
      if (!regex.test(x)) {
        // search is a number
        tempRegisterList = dataPointsList.filter((item) =>
          item.modbus_register_number.toString().includes(filters.searchValue),
        );
      } else {
        // search is text
        tempRegisterList = dataPointsList.filter((item) =>
          item.display_name
            .replace(/\s/g, '')
            .toLowerCase()
            .includes(filters.searchValue.replace(/\s/g, '').toLowerCase()),
        );
      }
    } else {
      tempRegisterList = dataPointsList;
    }

    const { sortValue, isReversed } = filters;

    switch (sortValue) {
      case 'selected':
        unsortedList = tempRegisterList;
        // if this is the first time sorting, or if the previous sort is not by selected
        if (!isReversed) {
          tempRegisterList = unsortedList.filter((item) => modalLineColorObj[item.tag] !== undefined);
          tempRegisterList = tempRegisterList.concat(
            unsortedList.filter((item) => modalLineColorObj[item.tag] === undefined),
          );
          break;
        }
        // previous sort is also by selected, we will sort in reverse
        tempRegisterList = unsortedList.filter((item) => modalLineColorObj[item.tag] === undefined);
        tempRegisterList = tempRegisterList.concat(
          unsortedList.filter((item) => modalLineColorObj[item.tag] !== undefined),
        );
        break;
      case 'modbus_register':
        // if this is the first time sorting, or if the previous sort is not by modbus_register
        if (!isReversed) {
          tempRegisterList = tempRegisterList.sort((a, b) => {
            if (a.modbus_register < b.modbus_register) return -1;
            if (a.modbus_register > b.modbus_register) return 1;
            return 0;
          });
          break;
        }
        // previous sort is also by modbus_register, we will sort in reverse
        tempRegisterList = tempRegisterList.sort((a, b) => {
          if (a.modbus_register > b.modbus_register) return -1;
          if (a.modbus_register < b.modbus_register) return 1;
          return 0;
        });
        break;
      case 'tag':
        // if this is the first time sorting, or if the previous sort is not by tag
        if (!isReversed) {
          tempRegisterList = tempRegisterList.sort((a, b) => {
            if (a.tag < b.tag) return -1;
            if (a.tag > b.tag) return 1;
            return 0;
          });
          break;
        }
        // previous sort is also by tag, we will sort in reverse
        tempRegisterList = tempRegisterList.sort((a, b) => {
          if (a.tag > b.tag) return -1;
          if (a.tag < b.tag) return 1;
          return 0;
        });
        break;
      case 'display_name':
        // if this is the first time sorting, or if the previous sort is not by display_name
        if (!isReversed) {
          tempRegisterList = tempRegisterList.sort((a, b) => {
            if (a.display_name < b.display_name) return -1;
            if (a.display_name > b.display_name) return 1;
            return 0;
          });
          break;
        }
        // previous sort is also by display_name, we will sort in reverse
        tempRegisterList = tempRegisterList.sort((a, b) => {
          if (a.display_name > b.display_name) return -1;
          if (a.display_name < b.display_name) return 1;
          return 0;
        });
        break;
      default:
        tempRegisterList = dataPointsList;
    }

    this.setState((state) => ({
      ...state,
      filters: filterList,
      filteredRegisterList: tempRegisterList,
    }));
  }

  clearAll = () => {
    const defaultAvailableColors = ['line0', 'line1', 'line2', 'line3', 'line4', 'line5', 'line6'];

    this.setState((state) => ({
      ...state,
      modalLineColorObj: {},
      modalAvailableColors: defaultAvailableColors,
    }));

    this.renderModalItems();
  };

  updateEditable = (e, tag) => {
    const { value } = e.target;

    this.setState((state) => ({
      ...state,
      editableContent: {
        ...state.editableContent,
        [tag]: value,
      },
    }));
  };

  updateDataPointName = (e, updateApiLocation) => {
    const {
      updateDataPointName,
      navigationParams: { selectedSubCategory },
    } = this.props;
    const { value } = e.target;

    updateDataPointName(value, updateApiLocation, selectedSubCategory.api_location);
  };

  renderModalItems() {
    const { dataPointsList, isStaff, setEditingState } = this.props;
    const { modalLineColorObj, editableContent } = this.state;

    // initially the filteredRegisterList is empty
    const modalDataPointList =
      this.state.filteredRegisterList.length === 0 && !this.state.filters.searchValue
        ? dataPointsList
        : this.state.filteredRegisterList;

    return (
      <div className="diagnostics-modal__items">
        {modalDataPointList.map((dataPoint) => {
          const { status, modbus_register, display_name, is_darksky_data, tag, update_api_location } = dataPoint;
          const isSelected = modalLineColorObj[tag] !== undefined;
          const dataPointClass = 'diagnostics-modal__column';
          const desktopClass = ' diagnostics-modal__column--desktop ';
          const disabledClass = Object.keys(modalLineColorObj).length >= 7 && !isSelected ? ' disabled' : '';
          const selectedItemClass = isSelected
            ? 'diagnostics-modal__registry-item diagnostics-modal__registry-item--selected'
            : 'diagnostics-modal__registry-item';
          const selectedLineClass = isSelected ? `line ${modalLineColorObj[tag]}` : '';
          const dataPointNumber = modbus_register;
          const dataTag = tag;
          const isDarkSkyData = is_darksky_data;
          const updateApiLocation = update_api_location;
          const editableText = editableContent[dataTag] || display_name;

          return (
            <label htmlFor={tag} key={tag}>
              <div className={selectedItemClass + disabledClass}>
                <div className={dataPointClass}>
                  <input
                    type="checkbox"
                    id={tag}
                    key={tag}
                    className="diagnostics-modal__checkbox"
                    checked={isSelected}
                    onChange={() => this.handleCheckboxChange(tag)}
                    disabled={disabledClass}
                  />
                </div>
                <div className={dataPointClass + desktopClass + disabledClass}>
                  <div className={selectedLineClass} />
                </div>
                <div className={dataPointClass + disabledClass}>{dataPointNumber}</div>
                <div className={dataPointClass + disabledClass}>{dataTag}</div>
                <div className={dataPointClass + ' diagnostics-modal__column--wide ' + disabledClass}>
                  {isStaff ? (
                    <InlineEditable text={editableText} type="input" setEditingState={setEditingState}>
                      <input
                        type="text"
                        name="dataPoint"
                        value={editableText}
                        onChange={(e) => this.updateEditable(e, dataTag)}
                        onBlur={(e) => this.updateDataPointName(e, updateApiLocation)}
                        autoFocus
                      />
                    </InlineEditable>
                  ) : (
                    display_name
                  )}
                  {isDarkSkyData && (
                    <a href="https://darksky.net/poweredby/" target="_blank" rel="noopener noreferrer">
                      <img className="diagnostics-modal__dark-sky-icon" src={darkSkyIcon} alt="dark sky" />
                    </a>
                  )}
                </div>
                <div className={dataPointClass + desktopClass + disabledClass}>{status}</div>
              </div>
            </label>
          );
        })}
      </div>
    );
  }

  render() {
    const { modalLineColorObj, modalAvailableColors } = this.state;
    const { sortValue, isReversed } = this.state.filters;
    const modalColumnClass = 'diagnostics-modal__column-name';
    const numSelectedLines = Object.keys(modalLineColorObj).length;
    const isMaxSelected = numSelectedLines === 7;

    return (
      <Modal>
        <div className="diagnostics-modal-overlay">
          <div className="diagnostics-modal">
            <div className="diagnostics-modal__header">
              <span className="diagnostics-modal__header-item diagnostics-modal__header-item--left">
                <button className="diagnostics-modal__clear-all" onClick={this.clearAll}>
                  Clear All
                </button>
              </span>
              <span className="diagnostics-modal__header-item diagnostics-modal__header-item--center diagnostics-modal__title">
                <span className="diagnostics-modal__title--margin">Select data sets</span>
                <span
                  className={isMaxSelected ? 'diagnostics-modal__title--red' : ''}
                >{` (${numSelectedLines} of 7)`}</span>
              </span>
              <span className="diagnostics-modal__header-item diagnostics-modal__header-item--right">
                <input
                  className="diagnostics-modal__close-button"
                  type="button"
                  onClick={() => this.handleModalClose()}
                />
              </span>
            </div>
            <div className="diagnostics-modal__filters">
              <SearchBar
                value={this.state.filters.searchValue}
                placeholderText="Search for a data point"
                onChange={this.updateSearchValue}
              />
            </div>
            <div className="diagnostics-modal__column-name-wrapper">
              <button
                className={
                  sortValue === 'selected'
                    ? `${modalColumnClass} diagnostics-modal__column-name--selected`
                    : modalColumnClass
                }
                onClick={() => this.updateSortValue('selected')}
              >
                <span className="diagnostics-modal__column-name-text">SELECTED</span>
                <ColumnArrow value="selected" sortValue={sortValue} isReversed={isReversed} />
              </button>
              <span className="diagnostics-modal__column-name diagnostics-modal__column-name--desktop">LINE STYLE</span>
              <button
                className={
                  sortValue === 'modbus_register'
                    ? `${modalColumnClass} diagnostics-modal__column-name--selected`
                    : modalColumnClass
                }
                onClick={() => this.updateSortValue('modbus_register')}
              >
                <span className="diagnostics-modal__column-name-text">MODBUS REGISTER</span>
                <ColumnArrow value="modbus_register" sortValue={sortValue} isReversed={isReversed} />
              </button>
              <button
                className={
                  sortValue === 'tag'
                    ? `${modalColumnClass} diagnostics-modal__column-name--selected`
                    : modalColumnClass
                }
                onClick={() => this.updateSortValue('tag')}
              >
                <span className="diagnostics-modal__column-name-text">DATA TAG</span>
                <ColumnArrow value="tag" sortValue={sortValue} isReversed={isReversed} />
              </button>
              <button
                className={
                  sortValue === 'display_name'
                    ? `${modalColumnClass} diagnostics-modal__column-name--wide diagnostics-modal__column-name--selected`
                    : `${modalColumnClass} diagnostics-modal__column-name--wide`
                }
                onClick={() => this.updateSortValue('display_name')}
              >
                <span className="diagnostics-modal__column-name-text">DATA SET</span>
                <ColumnArrow value="display_name" sortValue={sortValue} isReversed={isReversed} />
              </button>
              <span className="diagnostics-modal__column-name diagnostics-modal__column-name--desktop">STATUS</span>
            </div>
            {this.renderModalItems()}
            <div className="diagnostics-modal__linebreak" />
            <div className="diagnostics-modal__buttons">
              <div className="diagnostics-modal__button diagnostics-modal__button-cancel">
                <GreyButton label="Cancel" onClick={() => this.handleModalClose()} fullWidth={true} />
              </div>
              <div className="diagnostics-modal__button">
                <PrimaryButton
                  icon="save-icon"
                  label="Save Changes"
                  isDisabled={Object.keys(this.state.modalLineColorObj).length === 0}
                  onClick={() => this.props.saveChanges(modalLineColorObj, modalAvailableColors)}
                  fullWidth={true}
                />
              </div>
            </div>
          </div>
        </div>
      </Modal>
    );
  }
}

DiagnosticsModal.propTypes = {
  onRequestClose: PropTypes.func.isRequired,
  dataPointsList: PropTypes.arrayOf(
    PropTypes.shape({
      api_location: PropTypes.string,
      is_default: PropTypes.bool,
      id: PropTypes.number,
      display_name: PropTypes.string,
      modbus_device: PropTypes.number,
      modbus_register_number: PropTypes.number,
      status: PropTypes.string,
      tag: PropTypes.string,
    }),
  ),
  saveChanges: PropTypes.func.isRequired,
  updateDataPointName: PropTypes.func.isRequired,
  setEditingState: PropTypes.func.isRequired,
};

DiagnosticsModal.defaultProps = {
  dataPointsList: [],
};

function mapStateToProps(state) {
  return {
    dataPointsList: state.diagnosticsReducer.dataPointsList,
    navigationParams: state.buildingReducer.navigationParams,
    isStaff: state.profileReducer.is_staff,
  };
}

const mapDispatchToProps = {
  updateDataPointName: DiagnosticsActions.updateDataPointName,
};

const ConnectedDiagnosticsModal = connect(mapStateToProps, mapDispatchToProps)(DiagnosticsModal);
export { ConnectedDiagnosticsModal };
